// import {DodgerBlueColor} from '../../cmsMainStyle'

const userGroupStyle = theme => ({


})

export {userGroupStyle}